module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image@2-fbf6ae02169cbd92b4a87f4192484baf.jpg";